import React, { useEffect } from "react";
import "./ShopManagement.css";
import MyButton from "../components/MyButton";
import AddIcon from "@mui/icons-material/Add";
import {
  fetchMouvementType,
  setselectedMouvement,
} from "../store/mouvementTypesSlice";
import { useSelector, useDispatch } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import DisplaySales from "../components/dataDisplay/DisplaySales";
import {
  deleteSale,
  setSelectedSale,
  clearSelectedSale,
  clearSalesData
} from "../store/salesSlice";
import MyConfirmation from "../components/MyConfirmation";
import DisplayStocks from "../components/dataDisplay/DisplayStocks";
import { clearSelectedShop } from "../store/shopSlice";
import {
  checkCreatePermissionBasedOnMouvementType,
  checkDeletePermissionBasedOnMouvementType,
  checkUpdatePermissionBasedOnMouvementType,
} from "../services/utils";
import useSaleDocument from "../services/useSaleDocument";
import { showSnackbar } from "../store/snackbarSlice";
import { clearAlerts } from "../store/salesSlice";
import { DocumentIdName } from "../services/Enums";
import { usePermissions } from "../services/PermissionsContext";



const ShopManagement = () => {
 // const [dialogOpen, setDialogOpen] = useState(false);
  //const [dialogTitle, setDialogTitle] = useState("");
  //const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const { permissions } = usePermissions(); 
  const [ConfirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  const dispatch = useDispatch();
  
  const { openSaleDocument, SaleDialog } = useSaleDocument();
const { message, error } = useSelector((state) => state.sale);
useEffect(() => {
    if (message || error) {
      const type = message ? "success" : "error";
      const content = message || error;

      // Show snackbar with appropriate type
      dispatch(showSnackbar({ message: content, severity: type }));
      dispatch(clearAlerts());
      // Clear the form and fetch articles if successful
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, error]);

  
  const { mouvementTypes = [] } =
    useSelector((state) => state.mouvementTypes) || {};
  const { selectedMouvement } =
    useSelector((state) => state.mouvementTypes) || {};
  const { selectedSale } = useSelector((state) => state.sale) || {};

  useEffect(() => {
    dispatch(fetchMouvementType());
  }, [dispatch]);

  useEffect(() => {
    if (!selectedMouvement && mouvementTypes.length > 0) {
      const defaultMouvement = mouvementTypes[0]; // Choose the first item as default, or customize the logic
      dispatch(setselectedMouvement(defaultMouvement));
    }
  }, [dispatch, mouvementTypes, selectedMouvement]);

  useEffect(() => {
    // Automatically set the first item as the default if not already selected
    if (!selectedMouvement && mouvementTypes.length > 0) {
      dispatch(setselectedMouvement(mouvementTypes[0]));
    }
  }, [mouvementTypes, selectedMouvement, dispatch]);

  useEffect(() => {
    return () => {
      // dispatch(clearSelectedShop());
      dispatch(clearAlerts())
      dispatch(clearSalesData())
    };
  }, [dispatch]);

  // const openDialog = (mouvementType) => {
  //   if (!mouvementType) return;
  //   dispatch(setselectedMouvement(mouvementType));
  //   setDialogTitle(mouvementType.name || "Unknown");
  //   setDialogOpen(true);
  // };

  // const closeDialog = () => {
  //   if (hasUnsavedChanges) {
  //     const confirmClose = window.confirm(
  //       "You have unsaved changes. Do you really want to close?"
  //     );
  //     if (!confirmClose) return;
  //   }
  //   setDialogOpen(false);
  // };

  const handleChangeMouvement = (event) => {
    const mouvementType = mouvementTypes.find(
      (type) => type.name === event.target.value
    );
    if (mouvementType) {
      dispatch(setselectedMouvement(mouvementType));
    }
  };

  const actions = [
    {
      label: "Edit",
      type: "update",
      action: checkUpdatePermissionBasedOnMouvementType(selectedMouvement?._id),
      callback: (item) => {
        dispatch(setSelectedSale(item));
        openSaleDocument(selectedMouvement, item);
      },
    },

    {
      label: "Delete",
      type: "delete",
      action: checkDeletePermissionBasedOnMouvementType(selectedMouvement?._id),

      callback: (item) => {
        dispatch(setSelectedSale(item));
        handleOpenConfirmDialog();
      },
    },
  ];

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };

  const handleConfirm = () => {
    dispatch(deleteSale(selectedSale));
    dispatch(clearSelectedSale());
    setConfirmDialogOpen(false);
  };

  const handleCancel = (item) => {
    dispatch(clearSelectedSale());
    setConfirmDialogOpen(false);
  };

  const storedUser = sessionStorage.getItem("user");
  let userHasRestrictions = false; // Default: No restrictions
  
  if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      if (parsedUser.role) {
          // Check if the user is a manager and apply restrictions
          if (parsedUser.role === "magasinier") {
              userHasRestrictions = true;
          }
      }
  }
  
  const excludedIds = userHasRestrictions
    ? [DocumentIdName.LIVRAISON, DocumentIdName.ORDRE_DE_LIVRAISON, DocumentIdName.COMMANDE_CLIENT]
    : []; // No exclusions if the user has full access
  
  return (
    <div className="ShopManageMainDiv">
      <div className="Entete">
        <FormControl fullWidth>
          <InputLabel id="mouvement-type-label">Type Document</InputLabel>
          <Select
            labelId="mouvement-type-label"
            id="mouvement-type-select"
            value={selectedMouvement?.name || ""}
            label="Type Document"
            onChange={handleChangeMouvement}
          >
            {mouvementTypes      
            .filter((mouvementType) => !excludedIds.includes(mouvementType?._id)) // Exclude if needed
            .map((mouvementType) => (
              <MenuItem
                key={mouvementType?._id || `unknown-${Math.random()}`}
                value={mouvementType?.name || ""}
              >
                {mouvementType?.name || "Unnamed Type"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <MyButton
          key={selectedMouvement?._id || "default-key"}
          type="create"
          action={checkCreatePermissionBasedOnMouvementType(
            selectedMouvement?._id
          )}
          onClick={() => openSaleDocument(selectedMouvement)}
        >
          <AddIcon />
          {`Insert ${selectedMouvement?.name || "Type"}`}
        </MyButton>
      </div>

      <div className="documentDisplayDiv">
        <DisplaySales actions={actions} />
      </div>

      {permissions.routing.canAccessStockGenerale && (
        
      <div className="documentDisplayDiv">
        <DisplayStocks />
      </div>
      
       )}
          {SaleDialog}

      <MyConfirmation
        open={ConfirmDialogOpen}
        title="Delete Item"
        description={`Are you sure you want to delete this item ? ${
          selectedSale?.numero || ""
        }`}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        confirmText="Delete"
        cancelText="Cancel"
      />
    </div>
  );
};

export default ShopManagement;
